import { Color } from "../config.styles"


export default {
	container: {
		minWidth: "1000px",
		width: "100%",
		"@media (max-width:1350px)": {
			minWidth: "100%"
		}
	},
	logo: {
		margin: "-25px 0px 25px",
		maxWidth: "200px",
		alignSelf: "center",
		zIndex: "99"
	},
	flowContainer: {
		flexDirection: "row",
		backgroundColor: "#fff",
		borderRadius: "40px",
		boxShadow: "0 40px 80px rgba(54, 81, 144, 0.12)",
		"@media (max-width:767px)": {
			flexDirection: "column",
			borderRadius: "20px"
		}
	},
	roadmapContainer: {
		padding: "57px 20px 57px 42px",
		maxWidth: "354px",
		flexBasis: "354px",
		background: "#e5f1ff",
		borderRadius: "40px 0 0 40px",
		"@media (max-width:1024px)": {
			padding: "50px 25px",
			maxWidth: "250px",
			flexBasis: "250px"
		},
		"@media (max-width:767px)": {
			padding: "15px",
			maxWidth: "100%",
			flexBasis: "100%",
			borderRadius: "20px 20px 0 0"
		}
	},
	mobileRoadmapContainer: {
		display: "none",
		"@media (max-width:767px)": {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
			alignItems: "center"
		}
	},
	mobileRoadmapHeader: {
		fontSize: "24px !important",
		fontWeight: "600"
	},
	mobileRoadmapArrow(displayRoadmap) {
		return {
			transform: displayRoadmap ? "rotate(180deg)" : "rotate(0deg)",
			transition: "transform 0.2s ease"
		}
	},
	roadmap(displayRoadmap) {
		return {
			"@media (max-width:767px)": {
				margin: displayRoadmap ? "10px 0" : "0 0",
				display: displayRoadmap ? "block" : "none"
			}
		}
	},
	formContainer: {
		gap: "10px",
		"@media (max-width:767px)": {
			marginBottom: "7px",
			gap: "0px"
		}
	},
	formLabel(isCurrent, disabled) {
		// Determine color based on state priority:
		// 1. Complete -> green
		// 2. Not editable -> gray
		// 3. Editable (default) -> dark blue
		// console.log(`formLabel called with selected: ${selected}, disabled: ${disabled}, isComplete: ${isComplete}, isCurrent: ${isCurrent}, isEditable: ${isEditable}`);
		let color;
		if (isCurrent) {
			color = Color.tertiary;
		} else if (!disabled) {
			color = Color.primary;
		} else {
			color = Color.gray;
		}

		const isClickable = !disabled & !isCurrent;

		return {
			lineHeight: "32px",
			color: color,
			fontSize: "24px",
			fontWeight: "600",
			cursor: isClickable ? "pointer" : "default",
			"@media (max-width:767px)": {
				fontSize: "20px"
			}
		}
	},
	stepsContainer(selected) {
		return {
			gap: "10px",
			paddingLeft: "15px",
			maxHeight: selected ? "400px" : "0px",
			overflow: "hidden",
			transition: "all .2s ease",
			"@media (max-width:767px)": {
				gap: "10px"
			},
			"& > div:last-of-type": {
				marginBottom: "15px",
				"@media (max-width:767px)": {
					marginBottom: "5px"
				}
			},
			"& > div:first-of-type": {
				"@media(max-width: 767px)": {
					marginTop: "7px"
				}
			}
		}
	},
	step(isCurrentStep, disabled = false, subMenu = false) {
		// Determine color based on state priority:
		// 1. Not editable -> gray
		// 2. Completed or current -> dark blue
		// 3. Not yet started -> gray
		// console.log(`step called with isCurrentStep: ${isCurrentStep}, isCompletedStep: ${isCompletedStep}, disabled: ${disabled}, subMenu: ${subMenu}, isEditable: ${isEditable}`);
		let color;
		if (isCurrentStep) {
			color = Color.tertiary;
		} else if (!disabled) {
			color = Color.primary;
		} else {
			color = Color.gray;
		}

		const isClickable = !disabled && !isCurrentStep;

		return {
			lineHeight: "24px",
			paddingLeft: subMenu ? '35px' : (isCurrentStep ? "23px" : "0px"),
			position: isCurrentStep ? "relative" : "static",
			color: color,
			fontSize: "16px",
			fontWeight: "600",
			cursor: isClickable ? "pointer" : "default",
			transition: "all .2s ease",
			"@media (max-width:1024px)": {
				fontSize: "14px"
			},
			"@media (max-width:767px)": {
				marginBottom: "0px"
			},
			// ...(isCurrentStep && {
			// 	"&::before": {
			// 		content: "''",
			// 		width: "14px",
			// 		height: "12px",
			// 		position: "absolute",
			// 		top: "50%",
			// 		left: 0,
			// 		backgroundImage: `url(/assets/images/onboarding/arrow-right.svg)`,
			// 		transform: "translateY(-50%)"
			// 	}
			// })
		}
	},
	form: {
		padding: "35px 56px",
		width: "100%",
		minHeight: "670px",
		margin: '0px auto',
		flex: "1",
		"@media (max-width:1024px)": {
			padding: "35px 25px"
		},
		"@media (max-width:767px)": {
			padding: "25px 15px",
			minHeight: "auto"
		},
		"& form": {
			display: "flex",
			flexDirection: "column",
			height: "100%"
		}
	}
}